export default __webpack_public_path__ + "static/media/redo.3108d1c4.svg";